import reducer from "./reducer";
export { default as FestivitiesTable } from "./components/index";
export { default as festivitiesTableReducerName } from "./constants";
export default reducer;
